import * as React from 'react';

import {StudentTheme} from '../studentTheme';

import {AnthropometricsScreen} from './AnthropometricsScreen';
import {ChallengesScreen} from './ChallengesScreen';
import {CompletionsScreen} from './CompletionsScreen';
import {CoursesScreen} from './CoursesScreen';
import {FavoritesScreen} from './FavoritesScreen';
import {MenuScreen} from './MenuScreen';
import {RecordsScreen} from './RecordsScreen';
import {TimerScreen} from './TimerScreen';
import {ScheduleScreen} from './ScheduleScreen';
import {SocialScreen} from './SocialScreen';
import {WodsScreen} from './WodsScreen';

export interface ScreenOptions {
  programFilter?: string | null;
  columnList?: string | null;
  navEnabled?: string | null;
}

export interface AccountScreens {
  wodListDate?: ScreenOptions | null;
  wodList?: ScreenOptions | null;
  wods?: ScreenOptions | null;
  [outra: string]: ScreenOptions | null | undefined;
}

export interface ScreenProps {
  theme: StudentTheme;
  programFilter?: string | null;
  columnList?: string | null;
  screens?: AccountScreens | null;
}

// Rotas ja implementadas. O que nao estiver aqui cai no placeholder, entao
// portar uma tela nova e acrescentar uma linha — a navegacao por conta ja
// funciona para todas as abas.
//
// As quatro rotas de treino compartilham a mesma tela, como no app mobile;
// o que muda entre elas e o programFilter que a conta configurou.
export const SCREEN_COMPONENTS: Record<string, React.FC<ScreenProps>> = {
  social: SocialScreen,
  schedule: ScheduleScreen,
  courses: CoursesScreen,
  profile: MenuScreen,
  records: RecordsScreen,
  favorites: FavoritesScreen,
  completions: CompletionsScreen,
  timer: TimerScreen,
  anthropometrics: AnthropometricsScreen,
  challenges: ChallengesScreen,
  wodListDate: WodsScreen,
  wodList: WodsScreen,
  wods: WodsScreen,
  trainer: WodsScreen,
};

export const screenComponentFor = (rota: string): React.FC<ScreenProps> | null =>
  SCREEN_COMPONENTS[rota] ?? null;

// `trainer` nao tem entrada propria em settings.screens; o mobile trata a tela
// como variacao de wods, entao herda o filtro dela.
const FILTRO_HERDADO: Record<string, string> = {trainer: 'wods'};

export const programFilterFor = (rota: string, screens?: AccountScreens | null): string | null => {
  if (!screens) return null;

  const chave = FILTRO_HERDADO[rota] ?? rota;

  return screens[chave]?.programFilter ?? null;
};

export const columnListFor = (rota: string, screens?: AccountScreens | null): string | null =>
  screens?.[rota]?.columnList ?? null;
